import { alpha } from "@mui/material/styles";

// ✅ UNCHANGED — original primary, nothing breaks
const primaryMain = "#145238";
export const primary = {
  light: "#E5F3FD",
  main: primaryMain,
  100: alpha(primaryMain, 0.08),
  200: alpha(primaryMain, 0.2),
  300: alpha(primaryMain, 0.3),
  400: alpha(primaryMain, 0.4),
  red: "#FF6B93",
  purple: "#A798FF",
  yellow: "#FF9777"
};

const primaryDarkMain = "#4ade80";
export const primaryDark = {
  light: "#86efac",
  main: primaryDarkMain,
  100: alpha(primaryDarkMain, 0.12),
  200: alpha(primaryDarkMain, 0.25),
  300: alpha(primaryDarkMain, 0.4),
  400: alpha(primaryDarkMain, 0.5),
  red: "#FF6B93",
  purple: "#A798FF",
  yellow: "#FF9777"
};

const secondaryMain = "#23C657";
export const secondary = {
  light: "#E3F0FF",
  main: secondaryMain,
  dark: "#011E3D",
  100: alpha(secondaryMain, 0.08),
  200: alpha(secondaryMain, 0.2),
  300: alpha(secondaryMain, 0.3),
  400: alpha(secondaryMain, 0.4)
};

// ✅ UNCHANGED
export const info = {
  light: "#F4F4FF",
  main: "#8C8DFF",
  dark: "#0C53B7"
};

export const success = {
  light: "#EAFBF4",
  main: "#27CE88",
  dark: "#229A16"
};

export const warning = {
  light: "#FFFAF2",
  main: "#FFC675",
  dark: "#B78103"
};

// ✅ UNCHANGED
export const error = {
  light: "#FFEBF1",
  main: "#EF4444",
  dark: "#B72136"
};

// ✅ Edit button color
export const editGreen = {
  light: "#F0FDF4",
  main: "#22C55E",
  dark: "#16A34A",
  contrastText: "#fff"
};

// ✅ View button color
export const viewBlue = {
  light: "#EFF6FF",
  main: "#2563EB",
  dark: "#1D4ED8",
  contrastText: "#fff"
};

export const greyLight = {
  50: "#f9f9f9",
  100: "#eff3f5",
  200: "#c1c7e8",
  300: "#B1C9DC",
  400: "#8CA3BA",
  500: "#5F748D",
  600: "#455A79",
  700: "#2F4365",
  800: "#1E2E51",
  900: "#121F43"
};

export const greyDark = {
  900: "#E9F3F9",
  800: "#D3E6F3",
  700: "#B1C9DC",
  600: "#8CA3BA",
  500: "#5F748D",
  400: "#455A79",
  300: "#2F4365",
  200: "#1E2E51",
  100: "#121F43",
  50: "#111111"
};

export const textLight = {
  primary: greyLight[900],
  secondary: greyLight[500],
  disabled: greyLight[400]
};

export const textDark = {
  primary: "#ffffff",
  secondary: greyDark[600],
  disabled: greyDark[400]
};

export const actionLight = {
  activatedOpacity: 0.12,
  active: alpha(greyLight[900], 0.54),
  disabled: greyLight[300],
  disabledBackground: alpha(greyLight[900], 0.12),
  disabledOpacity: 0.38,
  focus: alpha(greyLight[900], 0.12),
  focusOpacity: 0.12,
  hover: alpha(greyLight[900], 0.04),
  hoverOpacity: 0.04,
  selected: greyLight[100],
  selectedOpacity: 0.08
};

// ✅ NEW — Global Table Header constants
export const tableHeader = {
  backgroundColor: greyLight[200],   // #D3E6F3 — light mode
  padding: "16px",
  position: "sticky",
  top: 0,
  zIndex: 20,
};

export const tableHeaderDark = {
  backgroundColor: greyDark[200],    // #1E2E51 — dark mode
  padding: "16px",
  position: "sticky",
  top: 0,
  zIndex: 20,
};

// ✅ NEW — Sticky Actions column (last column pinned to right)
export const tableHeaderStickyAction = {
  ...tableHeader,
  position: "sticky",
  right: 0,
  top: 0,
  zIndex: 21,
  width: 150,
};

export const tableHeaderStickyActionDark = {
  ...tableHeaderDark,
  position: "sticky",
  right: 0,
  top: 0,
  zIndex: 21,
  width: 150,
};

const palette = {
  info,
  error,
  primary,
  success,
  warning,
  secondary,
  editGreen,
  viewBlue,
};

export const lightPalette = {
  ...palette,
  mode: "light",
  grey: greyLight,
  text: textLight,
  action: actionLight,
  divider: greyLight[200],
  background: {
    default: "#f3f4f9",
    paper: "#ffffff"
  }
};

export const darkPalette = {
  ...palette,
  primary: primaryDark,
  mode: "dark",
  grey: greyDark,
  text: textDark,
  background: {
    default: "#171c24",
    paper: "#222b36"
  }
};